import {Button} from "@zendeskgarden/react-buttons";
import {Field, Input, Label} from "@zendeskgarden/react-forms";
import {Col, Row} from "@zendeskgarden/react-grid";
import {ReactElement} from "react";
import {useProperties} from "../../../contexts/properties/PropertiesContext";
import styles from "../AnalystPayrollDrawer.module.scss";
import {ensureDateInUtc} from "../date-helpers";
import {
    LocalPayrollEmployeeCompItemModel,
    LocalPayrollEmployeeModel,
    LocalPayrollEmployeeModelKeys
} from "../helpers/types";
import PayrollDatePicker from "./PayrollDatePicker";

interface BenefitEntryWithCompensationCapProps {
    index: number,
    subHeaderLabel: string,
    compItem: LocalPayrollEmployeeCompItemModel,
    allowRemove: boolean,
    employeeData: LocalPayrollEmployeeModel,
    updateFormState: (key: LocalPayrollEmployeeModelKeys, value: any) => void
}

export default function BenefitEntryWithCompensationCap({index, subHeaderLabel, compItem, allowRemove, employeeData, updateFormState}:BenefitEntryWithCompensationCapProps): ReactElement {
    const {currentProperty} = useProperties();
    const employeeLocked = employeeData.propertyLocked === true;

    return (
        <>
            <Field className={styles.field}>
                <Row justifyContent="between">
                    <Col>
                        <Label className={styles.benefitSubHeaders}>{subHeaderLabel} {index + 1}</Label>
                    </Col>
                    {
                        allowRemove && !employeeLocked && <Button isBasic isDanger onClick={() => {
                            updateFormState(LocalPayrollEmployeeModelKeys.removeCompItem, index);
                        }}>Remove</Button>
                    }
                </Row>
                <Row justifyContent="between">
                    <Col>
                        <Field className={styles.field}>
                            <Label className={styles.label}>% of Salary</Label>
                            <Input
                                placeholder="$"
                                value={compItem.costPerPayPeriod ?? ""}
                                type={"number"}
                                disabled={employeeLocked}
                                onChange={(evt) => {
                                    updateFormState(
                                        LocalPayrollEmployeeModelKeys.compItemsAmount,
                                        evt.target.value);
                                }}/>
                        </Field>
                    </Col>
                    <Col>
                        <Field className={styles.field}>
                            <Label className={styles.label}>Compensation Cap</Label>
                            <Input
                                placeholder="$ up to"
                                value={compItem.annualCostCap ?? ""}
                                type={"number"}
                                disabled={employeeLocked}
                                onChange={(evt) => {
                                    updateFormState(
                                        LocalPayrollEmployeeModelKeys.compItemsCompensationCap,
                                        evt.target.value);
                                }}
                            />
                        </Field>
                    </Col>
                </Row>
                <Row justifyContent="between">
                    <Col size={12}>
                        <Field className={styles.field}>
                            <Label className={styles.label}>Effective Date</Label>
                            <PayrollDatePicker
                                dateValue={compItem.effectiveStartDate ?? ""}
                                disabled={employeeLocked}
                                onDateChange={(newDate) => {
                                    if (currentProperty?.isAcquisitionProperty) {
                                        updateFormState(LocalPayrollEmployeeModelKeys.compItemsEffectiveDate, newDate);
                                    } else {
                                        updateFormState(LocalPayrollEmployeeModelKeys.compItemsEffectiveDate, ensureDateInUtc(newDate)?.toISOString());
                                    }
                                }}
                            />
                        </Field>
                    </Col>
                </Row>
            </Field>
        </>
    );
}
